<template lang="pug">
MarkupForm(
  button-text='Зарегистрироваться',
  :disabled='isDisabled || !agree || !is_accepted_consent_pdp',
  :messages='errorMessage',
  @submit='onSubmit'
)
  template(slot='buttons')
    .auth-services(v-if='isEsiaModule')
      EsiaLink.auth-services_btn
  template(slot='default')
    section.d-flex.flex-column.form-signup__wrapper(
      style='max-width: 720px',
      v-if='$store.state.regionProfile.regionId > 0'
    )
      .d-flex.flex-column
        p.personal_data_header.header_block Личные данные
        section.d-flex.flex-column
          form-input.parts-form-signup__field.personal_data_1_block(
            v-model.trim='lastName',
            label='Введите Вашу фамилию (для заполнений договоров и заявлений)',
            name='last_name',
            placeholder='Например, Иванов',
            :error='validStateMachine($v.lastName.$dirty, $v.lastName.$invalid)',
            :error-text='getMessage($v.lastName)',
            :required='true',
            @focus='$v.lastName.$reset()',
            @input='$v.lastName.$reset()',
            @blur='$v.lastName.$touch()'
          )
          form-input.parts-form-signup__field.personal_data_2_block(
            v-model.trim='firstName',
            label='Введите Ваше имя',
            name='first_name',
            placeholder='Например, Иван',
            :error='validStateMachine($v.firstName.$dirty, $v.firstName.$invalid)',
            :error-text='getMessage($v.firstName)',
            :required='true',
            @focus='$v.firstName.$reset()',
            @input='$v.firstName.$reset()',
            @blur='$v.firstName.$touch()'
          )
          form-input.parts-form-signup__field.personal_data_3_block.mb-10(
            v-model.trim='patroName',
            label='Введите Ваше отчество',
            name='middle_name',
            placeholder='Например, Иванович',
            :error='validStateMachine($v.patroName.$dirty, $v.patroName.$invalid)',
            :error-text='getMessage($v.patroName)',
            :required='false',
            @focus='$v.patroName.$reset()',
            @input='$v.patroName.$reset()',
            @blur='$v.patroName.$touch()'
          )
      section
        p.contact_details_header.header_block Контактные данные
        form-input.parts-form-signup__field.field_phone.contact_details_1_block(
          v-model.trim='phone',
          label='Введите номер мобильного телефона (для связи при обработке заявок)',
          name='phone',
          placeholder='В формате (926) 575-84-39',
          :error='validStateMachine($v.phone.$dirty, $v.phone.$invalid)',
          :error-text='getMessage($v.phone)',
          :mask='phoneMask',
          :appendPhone='true',
          :required='true',
          @focus='$v.phone.$reset()',
          @input='$v.phone.$reset()',
          @blur='$v.phone.$touch()'
        )
        form-input.parts-form-signup__field.contact_details_2_block.mb-10(
          v-model.trim='email',
          label='Введите email (для направления уведомлений)',
          name='email',
          placeholder='Например, mail@mail.ru',
          :error='validStateMachine($v.email.$dirty, $v.email.$invalid)',
          :error-text='(() => (typeof getMessage($v.email) == "string" ? getMessage($v.email) : getMessage($v.email)(email)))()',
          :warning='getWarning',
          :required='true',
          @focus='$v.email.$reset()',
          @input='$v.email.$reset(), resetServerValidation()',
          @blur='$v.email.$touch()'
        )
          Link(
            v-if='isEmailRegisteredError',
            slot='link',
            :to='{ hash: "#forget" }'
          ) Восстановить
      section
        p.password_header.header_block Пароль
        form-input.parts-form-signup__field.password_1_block(
          v-model.trim='password',
          :showPasswordEye='true',
          label='Выберите пароль (пароль вам пригодится, запомните или запишите его)',
          name='password',
          placeholder='Выберите пароль',
          type='password',
          :error='validStateMachine($v.password.$dirty, $v.password.$invalid)',
          :error-text='getMessage($v.password)',
          :required='true',
          @focus='$v.password.$reset()',
          @input='$v.password.$reset()',
          @blur='$v.password.$touch()'
        )
        form-input.parts-form-signup__field.password_2_block(
          v-model.trim='passwordConfirm',
          label='Повторите пароль',
          :showPasswordEye='true',
          name='passwordConfirm',
          placeholder='Повторите пароль',
          type='password',
          :error='errorsObject.passwordConfirm',
          :error-text='errorsText.passwordConfirm || "Пароли не совпадают"',
          :v='$v.passwordConfirm',
          :required='true',
          @focus='$v.password.$reset()',
          @input='$v.password.$reset()',
          @blur='$v.password.$touch()'
        )
        form-checkbox.password_3_block(v-model='agree', name='agree')
          template(slot='special')
            | Я ознакомлен и выражаю согласие с&nbsp;
            a(
              target='_blank',
              :href='$store.state.regionProfile.privacyPolicyFileUrl'
            ) политикой конфиденциальности и&nbsp;пользовательским соглашением*
        form-checkbox.password_3_block(
          v-model='is_accepted_consent_pdp',
          name='is_accepted_consent_pdp'
        )
          template(slot='special')
            | Я выражаю&nbsp;
            a(
              target='_blank',
              :href='$store.state.regionProfile.consentPdpFileUrl'
            ) согласие на обработку моих персональных данных*

    .form-signup__wrapper(v-else)
      | Регистрация на Портале Центра опережающей профессиональной подготовки временно недоступна в связи с проведением технических работ по настройке Портала
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { minLength, required } from 'vuelidate/lib/validators';
import {
  constMaskedPhone,
  getMessage,
  isUserFriendlyEmail,
  mailValidator,
  mayBeEmpty,
  noFirstLastMultipleWhiteSpace,
  validateFio,
  validStateMachine,
} from '@/tools/validators';
import { withParams } from 'vuelidate';

import { ACTIONS } from '@/store/user';

import signMixin from '../sign-mixin.js';
import { validateFioData } from '@/mixins/validateFioData';
import IsMunicipalityMixin from '@/mixins/isMunicipalityCheck.ts';
import IsEsiaCheckMixin from '@/mixins/isEsiaCheck';

import { FormInput as InputTest } from '@/pages/profile/blocks/form';
import PanelDashed from '@/components/markup/popup/form/dashed';
import FormButton from '@/components/ext/Button.vue';
import EsiaLink from '@/components/esialink';
import {
  Checkbox as FormCheckbox,
  Select as FormSelect,
} from '@/components/form';
import Link from '@/components/ext/Link.vue';

const { mapActions } = createNamespacedHelpers('user');

function getServerMessage(fieldName) {
  return this.errorsObject[fieldName] || '';
}
export default {
  name: 'ViewDefaultPopupFormSignup',

  components: {
    FormSelect,
    FormCheckbox,
    Link,
    InputTest,
    PanelDashed,
    FormButton,
    EsiaLink,
  },

  mixins: [signMixin, validateFioData, IsMunicipalityMixin, IsEsiaCheckMixin],

  validations() {
    const serverMessage = getServerMessage.bind(this);
    const problemEmails =
      this.$store.state.regionProfile.constants.problem_email_domains;

    const getMessageByInsertedEmail = (value) => {
      if (value) {
        return value.replace(/.*@/, '');
      } else {
        return '';
      }
    };

    const result = {
      lastName: {
        required: withParams({ $message: 'Укажите фамилию' }, required),
        validateFio: withParams(
          { $message: 'Используйте кириллицу' },
          validateFio
        ),
        minLength: withParams(
          { $message: 'Минимальная длинна фамилии 2 символа' },
          minLength(2)
        ),
        noFirstLastMultipleWhiteSpace: withParams(
          { $message: 'Вы ввели лишний пробел' },
          noFirstLastMultipleWhiteSpace
        ),
      },
      firstName: {
        notEmptyString: withParams({ $message: 'Укажите имя' }, required),
        validateFio: withParams(
          { $message: 'Используйте кириллицу' },
          validateFio
        ),
        minLength: withParams(
          { $message: 'Минимальная длинна имени 2 символа' },
          minLength(2)
        ),
        noFirstLastMultipleWhiteSpace: withParams(
          { $message: 'Вы ввели лишний пробел' },
          noFirstLastMultipleWhiteSpace
        ),
      },
      patroName: {
        validateFio: mayBeEmpty(
          withParams({ $message: 'Используйте кириллицу' }, validateFio)
        ),
        minLength: mayBeEmpty(
          withParams(
            { $message: 'Минимальная длинна фамилии 2 символа' },
            minLength(2)
          )
        ),
        noFirstLastMultipleWhiteSpace: withParams(
          { $message: 'Вы ввели лишний пробел' },
          noFirstLastMultipleWhiteSpace
        ),
      },
      phone: {
        required: withParams(
          { $message: 'Поле обязательно к заполнению' },
          required
        ),
        phone: withParams(
          { $message: 'Введите корректный номер телефона' },
          constMaskedPhone
        ),
        serverError: withParams(
          { $message: serverMessage('phone') },
          (value) => {
            return !!value.length && !serverMessage('phone').length;
          }
        ),
      },
      email: {
        mailValidator: withParams(
          { $message: 'Укажите корректный email' },
          mailValidator
        ),
        isUserFriendlyEmail: withParams(
          {
            $message: (value) =>
              `Уведомления не направляются на адреса с доменом ${getMessageByInsertedEmail(
                value
              )}. Укажите другой адрес.`,
          },
          isUserFriendlyEmail(
            problemEmails
              ? problemEmails.filter((el) => el !== 'gmail.com')
              : problemEmails
          )
        ),
        serverError: withParams(
          { $message: serverMessage('email') },
          (value) => {
            return !!value.length && !serverMessage('email').length;
          }
        ),
      },
      password: {
        required: withParams({ $message: 'Укажите пароль' }, required),
        serverError: withParams(
          { $message: serverMessage('password') },
          (value) => {
            return !!value.length && !serverMessage('password').length;
          }
        ),
      },
    };
    return result;
  },

  data() {
    return {
      lastName: '',
      firstName: '',
      patroName: '',
      email: '',
      password: '',
      passwordConfirm: '',
      regionId: this.$store.state.regionProfile.regionId || '',
      phone: '',
      agree: false,
      birthday: '',
      sex: '',
      snils: '',
      eduLevelId: '',
      is_accepted_consent_pdp: false,

      sexList: [
        {
          value: 'M',
          text: 'Мужской',
        },
        {
          value: 'W',
          text: 'Женский',
        },
      ],
    };
  },

  computed: {
    getWarning() {
      const problemEmails =
        this.$store.state.regionProfile.constants.problem_email_domains;
      const getMessageByInsertedEmail = (value) => {
        if (value) {
          return value.replace(/.*@/, '');
        } else {
          return '';
        }
      };
      if (
        problemEmails &&
        problemEmails.includes('gmail.com') &&
        !isUserFriendlyEmail(['gmail.com'])(this.email)
      ) {
        return `Уведомления не направляются на адреса с доменом ${getMessageByInsertedEmail(
          this.email
        )}. Укажите другой адрес.`;
      }
      return '';
    },
    buttonColor() {
      const { disabled } = this;
      return disabled ? 'disabled' : 'green';
    },
    disabled() {
      return this.isDisabled || !this.agree;
    },
    isDisableMunicipality() {
      const isDisable = !(
        this.$store.state.regionProfile.regionId > 0 &&
        +this.$store.state.regionProfile.regionId === +this.regionId
      );
      return isDisable;
    },
    dateMask: () => [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
    phoneMask: () => [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ],

    municipalities() {
      return this.$store.state.municipalities.map((m) => ({
        value: m.id,
        text: m.name,
      }));
    },
    regionsDict() {
      return this.$store.state.regionsDict.map((m) => ({
        value: m.id,
        text: m.name,
      }));
    },

    requestData() {
      const {
        email,
        password,
        passwordConfirm,
        firstName,
        lastName,
        patroName,
        phone,
        agree,
        is_accepted_consent_pdp,
      } = this;
      return {
        email,
        password,
        phone: `+7 ${phone}`,
        first_name: firstName,
        last_name: lastName,
        patro_name: patroName,
        password_confirm: passwordConfirm,
        is_consent_data: agree,
        is_accepted_consent_pdp: is_accepted_consent_pdp,
      };
    },

    message() {
      return this.hasErrors ? this.defaultErrorText : null;
    },

    rulesLink() {
      const { $router } = this;
      return $router.resolve({ name: 'terms' }).href;
    },
  },
  methods: {
    ...mapActions({ runAction: ACTIONS.SIGNUP }),

    resetServerValidation() {
      if (this.errors.length) {
        this.errors = [];
      }
    },

    onInput(value) {
      if (value) {
        this.formatFio(value);
        this.resetError(value);
      }
    },
    getStrRegxPatternBeforeCurrentYear() {
      function getCurrentYearByOctetIndex(index) {
        const curYear = new Date().getFullYear().toString().split('');
        return curYear[index];
      }
      return `([0-1][\\d]|2[0-${getCurrentYearByOctetIndex(3)}])`;
    },
    validStateMachine: validStateMachine,
    getMessage: getMessage,
  },
};
</script>

<style lang="stylus">
@import '~@/stylus/helpers/mediaqueriesStep'
.auth-services{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-weight: 700;

  &_btn{
    font-weight: 600;
    font-size: 14px;
    font-family: 'Open Sans';
    display: -ms-flexbox;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid #a9a9a9 !important;
    border-radius: 12px;
    cursor: pointer;
    display: flex !important;
    padding: 20px;
    margin: 0 !important;

    &:hover{
      background-color #fff
    }
  }
}
section > * {
  margin-bottom 10px
  display block
}

.form-signup__wrapper{
  display: block !important;
  overflow-y: auto;
  max-height: 70vh;

  +phone(){
    max-height: 60vh;
  }
}
.header_block{
  margin-bottom 10px
}
.personal_data{
  grid-area 1/1/1/3

  &__fields{
    display grid
    grid-template-columns 1fr 1fr
    gap 10px 20px
    align-items: end;
    +phone(){
      display: block !important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// ViewDefaultPopupFormSignup.vue?58904588